import { render, staticRenderFns } from "./gpc.vue?vue&type=template&id=0ff063a7&scoped=true&"
import script from "./gpc.vue?vue&type=script&lang=js&"
export * from "./gpc.vue?vue&type=script&lang=js&"
import style0 from "./gpc.vue?vue&type=style&index=0&id=0ff063a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff063a7",
  null
  
)

export default component.exports